import styled from 'styled-components'

export const FormTitle = styled.div.attrs({
})`           
    color: ${props => props.theme.palette.colors.text}; 
    font-family: Gilroy;
    font-size: 22px;
    font-weight: 700;
`;
export const FormText = styled.div.attrs({
})`           
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    color: ${props => props.theme.palette.colors.muted};
`;

export const FormSpacer = styled.div.attrs({
})`           
    margin-top: 40px;
`;
export const Container = styled.div.attrs({
})`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;
